import { REGIONS } from '@sitegen/common/constants';
import { COUNTRIES } from '@sitegen/common/localization/locations';

export const getCountryRegion = ( countryCode: string ): REGIONS | string => {
    switch (countryCode) {
    case 'US': return REGIONS.US;
    default: {
        const country = COUNTRIES.find( c => c.code === countryCode );
        return country?.region ?? '';
    }
    }
};
